jQuery(document).ready(function($) {
    jQuery('[name="season"]').on('change', () => {
        jQuery('.fantasy-league-loader').show();

        jQuery('.fantasy-overlay').show();
    
    })
    
    jQuery(window).load(function () {
        jQuery('.fantasy-overlay').hide();

        jQuery('.fantasy-league-loader').hide();
    });
});